import { render, staticRenderFns } from "./TYGLRYPieChart.vue?vue&type=template&id=dc998226&scoped=true"
import script from "./TYGLRYPieChart.vue?vue&type=script&lang=js"
export * from "./TYGLRYPieChart.vue?vue&type=script&lang=js"
import style0 from "./TYGLRYPieChart.vue?vue&type=style&index=0&id=dc998226&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc998226",
  null
  
)

export default component.exports